<form #form="ngForm" novalidade>
    <div class="card card-primary">
        <div class="card-header">
            <h6 class="card-title">
                Metas
            </h6>
            <small class="card-subtitle">Configurações das metas para este representante</small>
        </div>
        
        <ul class="list-group list-group-flush" *ngIf="entity">      
            <li class="list-group-item">
                <label class="col-form-label pb-0">
                    <input type="checkbox" [(ngModel)]="entity.considerarMediaGeralMeta" name="considerarMediaGeralMeta" id="considerarMediaGeralMeta"> Considerar na média geral
                </label>
                <p class="form-text text-muted">Marque esta opção para considerar este representante no cálculo da média geral das metas</p>
            </li>
            <li class="list-group-item">
                <label class="col-form-label pb-0">
                    <input type="checkbox" [(ngModel)]="entity.exibirRankMeta" name="exibirRankMeta" id="exibirRankMeta"> Exibir no Rank das Metas
                </label>
                <p class="form-text text-muted">Marque esta opção para considerar e exibir este representante no rank das metas</p>
            </li>
        </ul>                               
    </div>
</form>